import { request } from '../util/request'
import { AppCode } from '../util/auth'
import AES from '@/util/AES'

/**
 * /wechatUserBindPhone ，/web/authorize 两个方法新增参数，appCode=wxd1ba98bac159bb2c 用于区分公众号，
 * */

/**
 * @name GetImageVerifyCode
 * @desc 图形验证码
 * @param {object} params
 * @param {string} params.mobilePhone
 * @param {string} params.token
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function GetImageVerifyCode(data = {}, loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/wechatUser/getImageVerifyCode`,
        method: 'POST',
        data,
        responseType: 'arraybuffer',
        loadingConfig
    })
}

/**
 * @name LoginWechat
 * @desc 利用票据和openId获取用户信息和token
 * @param {object} data
 * @param {string} data.upod
 * @param {string} data.uptt
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function LoginWechat(data = {}, loadingConfig = {}) {
    data = JSON.parse(JSON.stringify(data))
    data.appCode = AppCode
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/wechatUser/loginWechat`,
        method: 'POST',
        data,
        loadingConfig
    })
}

/**
 * @name GetVerificationCode
 * @desc 获取短信验证码
 * @param {object} params
 * @param {string} params.mobilePhone
 * @param {string} params.token
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
// /services/front/wechatUser/getVerificationCode
export function GetVerificationCode(params = {}, loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/wechatUser/getVerificationCode`,
        method: 'GET',
        params,
        loadingConfig
    })
}

/**
 * @name WechatUserBindPhone
 * @desc 绑定手机号
 * @param {object} data
 * @param {string} data.open_id
 * @param {string} data.mobilePhone
 * @param {string} data.captcha
 * @param {string} data.token
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */

export function WechatUserBindPhone(data = {}, loadingConfig = {}) {
    data = JSON.parse(JSON.stringify(data))
    data.appCode = AppCode
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/wechatUser/wechatUserBindPhone`,
        method: 'POST',
        data,
        loadingConfig
    })
}

/**
 * @name FindUserInsurances
 * @desc 查询用户保单
 * @param {object} params
 * @param {string} params.insuredPersonMobileNumber
 * @param {token} params.token
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */

export function FindUserInsurances(params = {}, loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/findUserInsurances`,
        method: 'get',
        params,
        loadingConfig
    })
}

/**
 * @name FindUserInsuranceDetail
 * @desc 查询保单详情
 * @param {object} params
 * @param {string} params.id
 * @param {string} params.token
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function FindUserInsuranceDetail(params = {}, loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/findUserInsuranceDetail`,
        method: 'get',
        params,
        loadingConfig
    })
}

/**
 * @name FindUserInsurances
 * @desc 用户理赔保单列表
 * @param {object} params
 * @param {string} params.appntMobileNumber
 * @param {string} params.token
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */

export function FindUserInsuranceForSettling(params = {}, loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/findUserInsuranceForSettling`,
        method: 'get',
        params,
        loadingConfig
    })
}

/**
 * @name GetCompanyList
 * @desc 获取理赔
 * @param {object} params
 * @param {string} params.token
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function GetCompanyList(params = {}, loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/bizzUserResource/getCompanyList`,
        method: 'get',
        params,
        loadingConfig
    })
}

/**
 * @name GetCompanyList
 * @desc 获取电子保单
 * @param {object} params
 * @param {object} params.selfPolicySn
 * @param {string} params.token
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function FindInsurancePolicyUrl(data = {}, loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/findInsurancePolicyUrl`,
        method: 'post',
        data,
        loadingConfig
    })
}

/**
 * @name GetCompanyList
 * @desc 根据订单编号获取详细
 * @param {object} params
 * @param {object} params.orderSn
 * @param {string} params.token
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function FindInsurancePayOrderByOrderSn(
    params = {},
    loadingConfig = {}
) {
    params.orderSn = AES.encrypt(params.orderSn, 'MIGfMA0GCSqGSIb3')
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/insuranceOrderResource/findInsurancePayOrderByOrderSn`,
        method: 'get',
        params,
        loadingConfig
    })
}

/**
 * @name CloseUserInsured
 * @desc 取消订单接口
 * @param {object} params
 * @param {object} params.insuranceId
 * @param {string} params.token
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function CloseUserInsured(params = {}, loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/closeUserInsured`,
        method: 'get',
        params,
        loadingConfig
    })
}
/**
 * @name FindUserPersonInsuranceDetail
 * @desc 参保信息查询
 * @param {object} params
 * @param {object} params.insuranceProductCode
 * @param {object} params.payStatus
 * @param {object} params.insuredPersonName
 * @param {object} params.insuredPersonIdNo
 * @param {object} params.appCodeId
 * @param {string} params.token
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function FindUserPersonInsuranceDetail(params = {}, loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/findUserPersonInsuranceDetail`,
        method: 'get',
        params,
        loadingConfig
    })
}
/**
 * 获取服务器时间
 */
export function getSystemTime(loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/getNewDate`,
        method: 'get',
        loadingConfig
    })
}

/**
 * @name NewPayTrade
 * @desc 唤起支付平台
 * @param {object} data 
 * */

export function getPaymentUrl(data = {}, loadingConfig = {}) {
    data.orderSn = AES.encrypt(data.orderSn, 'MIGfMA0GCSqGSIb3')
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/paymentResource/getPaymentUrl`,
        method: 'post',
        data,
        loadingConfig
    })
}
//获取电子表单
export function findInsurancePolicyUrl(data = {}, loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/findInsurancePolicyUrl`,
        method: 'post',
        data,
        loadingConfig
    })
}


//更换手机号 确定旧手机号
// 入参：手机号，验证码
export function checkPhoneCaptcha(data = {}, loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/wechatUser/checkPhoneCaptcha`,
        method: 'post',
        data,
        loadingConfig
    })
}

//更换手机号
export function updateWechatUserPhone(data = {}, loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/wechatUser/updateWechatUserPhone`,
        method: 'post',
        data,
        loadingConfig
    })
}

// 核保验证接口
export function underwriteCheck(data = {}, loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/underwriteCheck`,
        method: 'post',
        data,
        loadingConfig
    })
}
// 取消个账预约
export function cancelReservation(data = {}, loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/medicalInfoResource/cancelReservation`,
        method: 'post',
        data,
        loadingConfig
    })
}

//换取神策id
// 入参：手机号
// {"mobilePhone":"13011002590"}
export function getThirdUserInfo(data = {}, loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/thirdUserDotResource/getThirdUserInfo`,
        method: 'post',
        data,
        loadingConfig
    })
}
/**
 * @name findUserInsurePersons
 * @desc 查询用户保单列表
 * @param {object} params
 * @param {token} params.token
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */

export function findUserInsurePersons(params = {}, loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/findUserInsurePersons`,
        method: 'get',
        params,
        loadingConfig
    })
}

// 获取电子表单

export function findPolicyUrl(data = {}, loadingConfig = {}) {
    return request({
        url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/findPolicyUrl`,
        method: 'post',
        data,
        loadingConfig
    })
}



